import AUTH from './AUTH';

export default {
    AUTH,
}



// WEBPACK FOOTER //
// ./src/services/enabled_services.js